// extracted by mini-css-extract-plugin
export default {"Card":"InsuranceCard_Card__eEoeO","Disabled":"InsuranceCard_Disabled__zYJ8y"};